module.exports = __webpack_public_path__ + "images/close80a594c19dac40387af989b1585f29cb.svg";